// extracted by mini-css-extract-plugin
export default {"option":"option_rf_Cq0Fy"};